import { Popup } from "./Popup"

interface Props {

    button: React.ReactElement
    disabled?: boolean

    /** CSS class applied to the outer popup wrapping the dropdown (i.e., directly in <body>) */
    popupCssClass?: string

    /** CSS class applied inside the popup */
    dropdownClass?: string

}

export function DropDownMenu({ button, children, dropdownClass, popupCssClass, disabled }: React.PropsWithChildren<Props>) {

    return <Popup
        popupContent={Content}
        popupContentProps={() => ({ children, dropdownClass })}
        disabled={disabled}
        popupCssClass={popupCssClass}
        wrapper={false}
        unstyled={true}
        align="topLeft"
        origin="bottomLeft"
        outsideClick={true}>

        {button}

    </Popup>

}

function Content({ dropdownClass, close, children }: React.PropsWithChildren<{ dropdownClass: string, close: Function }>) {

    return <ul
        id="help-menu-dropdown"
        className={`dropdown-menu ${dropdownClass || ""}`}
        style={{ display: "block", position: "static" }}
        role="menu"
        aria-labelledby="help-menu"
        onClick={e => close()}>

        {children}

    </ul>

}
